var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlled4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 9.14844C11.026 9.9401 10.8125 10.6406 10.4219 11.25C10.0312 11.8542 9.48177 12.3229 8.77344 12.6562C8.07031 12.9896 7.26562 13.1562 6.35938 13.1562C4.86458 13.1562 3.6875 12.6693 2.82812 11.6953C1.96875 10.7214 1.53906 9.34635 1.53906 7.57031V7.00781C1.53906 5.89323 1.73177 4.91927 2.11719 4.08594C2.50781 3.2474 3.06771 2.60156 3.79688 2.14844C4.52604 1.6901 5.36979 1.46094 6.32812 1.46094C7.70833 1.46094 8.81771 1.82552 9.65625 2.55469C10.4948 3.27865 10.9714 4.27865 11.0859 5.55469H8.35156C8.33073 4.86198 8.15625 4.36458 7.82812 4.0625C7.5 3.76042 7 3.60938 6.32812 3.60938C5.64583 3.60938 5.14583 3.86458 4.82812 4.375C4.51042 4.88542 4.34375 5.70052 4.32812 6.82031V7.625C4.32812 8.83854 4.47917 9.70573 4.78125 10.2266C5.08854 10.7474 5.61458 11.0078 6.35938 11.0078C6.98958 11.0078 7.47135 10.8594 7.80469 10.5625C8.13802 10.2656 8.3151 9.79427 8.33594 9.14844H11.0625ZM15.2812 13H12.5469V1.625H15.2812V13ZM21.6016 9.90625L23.8672 1.625H26.9297L23.1016 13H20.1016L16.3047 1.625H19.3438L21.6016 9.90625Z",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlled4);
export default __webpack_public_path__ + "static/media/controlled4.a5a340c2beda2a376eddcf73a08cd08f.svg";
export { ForwardRef as ReactComponent };